import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLazyGetAppPermissionQuery } from "@/services/caseSummary/caseSummaryReducer";
import { setAppPermission } from "../auth/appPermission-slice";

export const useAppPermission = (doFetch = false) => {
  const dispatch = useDispatch();

  const [getPermission, { data: permissionData }] = useLazyGetAppPermissionQuery();
  const updatePermission = useCallback(
    async () => {
        const permissionData = await getPermission(null).unwrap();
        dispatch(setAppPermission(permissionData));
    },
    [dispatch, getPermission]
  );
  useEffect(() => {
    if (doFetch) {
      updatePermission();
      return;
    }
    return () => {
      // cleanup
    };
  }, [ updatePermission, doFetch ]);

  return permissionData;
};
